export default __webpack_public_path__ + "static/media/night-sky.cfeaa68b.jpg";